<section class="dashboard">
    <div class="dashboard-lead-card">
        <div class="dashboard-lead-card-header">
            <span class="icon dashboard-lead-card-header-icon-box" svgIcon="assets/svg/icons/id-card-pan-gb.svg"></span>
            <h3 class="dashboard-lead-card-header-title">
                {{
                    stage === "UPLOAD_PAN_CARD"
                        ? "Your PAN E-KYC has expired. Update it again to continue"
                        : "Your PAN card is being verified. We’ll notify you once it’s done."
                }}
            </h3>
        </div>
        <div class="dashboard-lead-card-body">
            <div class="dashboard-lead-card-body-content">
                <button
                    type="button"
                    *ngIf="stage === 'UPLOAD_PAN_CARD'"
                    class="primary-gradient-btn btn-w100 apply-btn"
                    (click)="uploadPan()"
                >
                    Update PAN<img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                </button>
                <button
                    *ngIf="stage !== 'UPLOAD_PAN_CARD'"
                    type="button"
                    class="primary-fill-btn btn-w100 apply-btn"
                    [routerLink]="['/support']"
                >
                    Contact Support
                </button>
            </div>
        </div>
    </div>
</section>
